const DEFAULT_BADGE_CLASS_NAME = 'default-badge';

export default DEFAULT_BADGE_CLASS_NAME;
